<template>
<div class="form-group form-group-default required radio-group resource-type">
  <label class="text-transform-unset">
    {{ $t("SignUpForm.label_internal") }}
  </label>

  <div class="radio radio-success">
    <input type="radio"
           :id="internId"
           :name="fieldName"
           value="intern"
           :disabled="disabled"
           v-model="internalValue"
           @change="$emit('input', $event.target.value), InternOrExternCandidatEvent($event.target.value)"
           @input="$emit('input', $event.target.value)" />
    <label :for="internId">{{ $t('yes') }}</label>

    <input type="radio"
           :id="externId"
           :name="fieldName"
           value="extern"
           :disabled="disabled"
           v-model="internalValue"
           @change="$emit('input', $event.target.value), InternOrExternCandidatEvent($event.target.value)"
           @input="$emit('input', $event.target.value)" />
    <label :for="externId">{{ $t('no') }}</label>
  </div>
</div>
</template>

<script>
import AtInternetManagingCandidate from '@/helpers/at_internet/managing_candidate'

export default {
  name: 'ResourceTypeField',
  inject: ['$validator'],
  props: {
    value: String,
    disabled: Boolean,
    fieldNameAddition: { type: [String, Number], default: null }
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  mounted() {
    if(this.$route.name === "NewUser") this.InternOrExternCandidatEvent(this.internalValue)
  },
  watch: {
    value: function(value) {
      this.internalValue = value
    },
  },
  computed: {
    randomID() {
      return Math.floor((Math.random() * 100) + 1);
    },
    internId() {
      if(this.fieldNameAddition == null) {
        return `${this.randomID}resource_type_field-yes`;
      }
      return `${this.fieldNameAddition}-yes`
    },
    externId() {
      if(this.fieldNameAddition == null) {
        return `${this.randomID}resource_type_field-no`;
      }
      return `${this.fieldNameAddition}-no`
    },
    fieldName() {
      if(this.fieldNameAddition == null) {
        return `${this.randomID}resource_type_field`;
      }
      return `resource_type_${this.fieldNameAddition}`;
    }
  },
  methods: {
    InternOrExternCandidatEvent(value){
      value === "intern" ? AtInternetManagingCandidate.sendInternCandidatEvent() : AtInternetManagingCandidate.sendExternCandidatEvent()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/form/ResourceTypeField.vue